const STYLES = {
  "In Stock": "bg-[#E6F2EA] text-[#1B4332] border-[#1B4332]/20",
  "Low Stock": "bg-[#FBF1D6] text-[#7A5A0B] border-[#C59B27]/40",
  "Out of Stock": "bg-[#F6E4E1] text-[#8A2B1E] border-[#8A2B1E]/20",
  "Contact Us": "bg-[#F1ECE4] text-[#6B4520] border-[#8B5A2B]/25",
};

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${STYLES[status] || STYLES["Contact Us"]}`}>
    <span className="h-1.5 w-1.5 rounded-full bg-current" />
    {status === "Low Stock" ? "Few left" : status || "Contact Us"}
  </span>
);
